import { render, staticRenderFns } from "./admin_tools_dashboard.vue?vue&type=template&id=1f51bd38&scoped=true&"
import script from "./admin_tools_dashboard.vue?vue&type=script&lang=js&"
export * from "./admin_tools_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./admin_tools_dashboard.vue?vue&type=style&index=0&id=1f51bd38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f51bd38",
  null
  
)

export default component.exports